// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"3e578b59","466":"1011c57d","488":"5915bbf7","780":"ce8e3bcd","892":"de9d648f"}[chunkId] + ".chunk.js";
};